// extracted by mini-css-extract-plugin
module.exports = {"sub":"EmpCard_sub__2c7l3","card":"EmpCard_card__2iap4"};